<script setup>
onMounted(async () => {
    try {
        await loadExternalScript('apple-pay-sdk', 'https://applepay.cdn-apple.com/jsapi/v1.2.0-beta/apple-pay-sdk.js')
    } catch (error) {
        console.error('Failed to initialize Apple Pay:', error)
    }
})

// Function to handle Apple Pay
const startApplePay = async () => {
    if (window.ApplePaySession) {
        // Check if Apple Pay is available
        if (ApplePaySession.canMakePayments()) {
            const paymentRequest = {
                countryCode: 'US',
                currencyCode: 'USD',
                supportedNetworks: ['visa', 'masterCard', 'amex'],
                merchantCapabilities: ['supports3DS'],
                total: {
                    label: 'ECE',
                    amount: '10.00'
                }
            }

            const session = new ApplePaySession(1, paymentRequest)

            // Handle the Apple Pay session events
            session.onvalidatemerchant = (event) => {
                // Perform merchant validation
                // Replace with your own validation URL
                const validationURL = event.validationURL
                fetch('/api/validate-merchant', {
                    method: 'POST',
                    body: JSON.stringify({ validationURL })
                })
                    .then(response => response.json())
                    .then((merchantSession) => {
                        session.completeMerchantValidation(merchantSession)
                    })
                    .catch((error) => {
                        console.error('Merchant validation failed:', error)
                        session.abort()
                    })
            }

            session.onpaymentauthorized = (event) => {
                // Handle payment authorization
                const payment = event.payment
                // Process the payment
                fetch('/api/process-payment', {
                    method: 'POST',
                    body: JSON.stringify(payment)
                })
                    .then(response => response.json())
                    .then((result) => {
                        if (result.success) {
                            session.completePayment(ApplePaySession.STATUS_SUCCESS)
                        } else {
                            session.completePayment(ApplePaySession.STATUS_FAILURE)
                        }
                    })
                    .catch((error) => {
                        console.error('Payment processing failed:', error)
                        session.completePayment(ApplePaySession.STATUS_FAILURE)
                    })
            }

            session.begin()
        } else {
            alert('Apple Pay is not available on this device/browser')
        }
    } else {
        alert('Apple Pay is not supported in this browser')
    }
}
</script>

<template>
    <apple-pay-button buttonstyle="black" type="buy" locale="de-DE" @click="startApplePay" />
</template>

<style lang="scss">
apple-pay-button {
    --apple-pay-button-width: 100%;
    --apple-pay-button-height: 48px;
    --apple-pay-button-border-radius: 30px;
    --apple-pay-button-padding: 7px 7px;
    --apple-pay-button-box-sizing: border-box;

    max-width: 383px;
}
</style>
